// No imports on purpose: the test suite (on Workers, without a DOM) imports this file directly.

/**
 * What the sign-in card offers someone without an account. Nothing inside the Android or iPhone app:
 * accounts are made by the business on the web, and the store listings say the app has no sign-up,
 * so signing out in the app's dashboard view must not lead to one (or to the website to buy a plan).
 */
export function newAccountOffer({ inApp, signupEnabled }) {
  if (inApp) return null;
  return signupEnabled ? "signup" : "early_access";
}
